import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { API_URL } from "../../../utils/constant";
import axios from "axios";

export const getHomeTextSliceContent = createAsyncThunk('/homeTexts/content', async () => {
	const response = await axios.post(`${API_URL}/getHomeText`);
    console.log(response.data);
	return response;
})

export const homeTextSlice = createSlice({
    name: 'homeTexts',
    initialState: {
        isLoading: false,
        homeTexts : []
    },
    reducers: {
    },
    extraReducers: {
		[getHomeTextSliceContent.pending]: state => {
			state.isLoading = true
		},
		[getHomeTextSliceContent.fulfilled]: (state, action) => {
			state.homeTexts = action.payload.data
			state.isLoading = false
		},
		[getHomeTextSliceContent.rejected]: state => {
			state.isLoading = false
		},
    }
})

export default homeTextSlice.reducer